import { axios } from '@Root/API'

export const remove = id => {
	return axios.delete(`delete/moodle-link/${id}`)
}
